exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container.nav-header[data-v-28d9d782]{width:100%;height:auto;display:flex;-webkit-flex-direction:column;-moz-flex-direction:column;-ms-flex-direction:column;-o-flex-direction:column;flex-direction:column;justify-content:center;background-color:#2e3192}.container.nav-header a[data-v-28d9d782]{color:#fff;text-decoration:none}.container.nav-header a[data-v-28d9d782] :active,.container.nav-header a[data-v-28d9d782] :focus{outline:none!important}.homepage-headline[data-v-28d9d782]{margin:250px 0}.homepage-headline img[data-v-28d9d782]{margin:50 auto}@media (max-width:775px){.homepage-headline img[data-v-28d9d782]{width:90%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28d9d782","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HeaderHome.vue
// module id = 177
// module chunks = 0